export enum TypeOfVisit {
  BUSINESS = 1,
  COMPLETION_OF_THE_WORK = 2,
  TOUR = 3,
}
